import React from "react";
import "./FormattedDate.css";

export default function FormattedDate(props){
    let days = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday"];
    let day = days[props.date.getDay()];

    let hours = props.date.getHours()
    if (hours <10){
        hours = `0${hours}`;
    }
    let minutes = props.date.getMinutes();
    if (minutes <10){
        minutes = `0${minutes}`;
    }
    return <div className="FormattedDate">{day} {hours}:{minutes}</div>
        
    
}